import * as React from "react";
import './FormBroker.css'
import {formStores} from "../../../state/mobx";
import PlacesAutoCompleteContainer from "../../../../Bots/Common/PlacesAutoComplete/PlacesAutoCompleteContainer";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import FormButton from "../../../../../components/FormButton/FormButton";
import {observer} from "mobx-react";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper, {IStep} from "../../../components/FormStepper/FormStepper";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import {BrokersState} from "src/scenes/Forms/state/BrokersState";
import Icon from "src/components/Icon/Icon";
// @ts-ignore
import ResetFormBtn from "../../../../../components/ResetForm/resetFormBtn";
import {RouteComponentProps} from "react-router";

const BrokerView = true;
const storePropertyName = 'brokers';
const STORE = formStores.brokersStore;

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
}

interface ILocalState {
    selectedView: boolean;
    navigate : boolean;
    isLocationSelected: boolean;
    showWorkSpaceError: boolean;
}


@observer
export default class FormBroker  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        selectedView: BrokerView,
        navigate : false,
        isLocationSelected: false,
        showWorkSpaceError: false
    };

    constructor (props: IProps) {
        super(props);
        if(!STORE.formInput[storePropertyName]) {
            STORE.formInput[storePropertyName] = {};
        }
    }

    public selectPlace = (place: IGooglePlace | string) => {
        STORE.updateLocation(place);
        const newState = this.state;
        newState.isLocationSelected = true;
        newState.showWorkSpaceError = false;
        this.setState(newState);
    };

    public next = () => {
        if(STORE.currentScreen === BrokersState.welcome) {
            if(this.state.isLocationSelected) {
                STORE.updateScreen(BrokersState.informationClients);
            }else {
                const newState = this.state;
                newState.showWorkSpaceError = true;
                this.setState(newState);
            }
        }else if ( (STORE.currentScreen === BrokersState.informationClients || STORE.currentScreen === BrokersState.informationContact) && STORE.allowFinishForm ) {
            console.log()
            STORE.submit();
        }
    };

    public renderNextButton = () => {
        return <FormButton classes={"yellow"} click={this.next} btnText={'Get started'}/>;
    };

    public renderSubmitButton = () => {
        const btnClasses = STORE.allowFinishForm? 'yellow' : 'disabled';
        return <FormButton classes={btnClasses} click={this.next} btnText={'Submit'}/>;
    };

    public getSteps() {
        if (this.state.selectedView === BrokerView) {
            return [
                {
                    isHeader: true,
                    title: "Contact Information",
                    inputType: InputTypes.none
                },
                {
                    title: "Your Full Name",
                    inputType: InputTypes.text,
                    inputPlaceHolder: "Write here...",
                    propName: "fullName"
                },
                {
                    title: "Work Email Address",
                    inputType: InputTypes.email,
                    inputPlaceHolder: "Write here...",
                    propName: "workEmail",
                    errorController: !STORE.isEmailValid,
                    errorLabel: STORE.getEmailErrorMessage
                },
                {
                    title: "Phone Number",
                    inputType: InputTypes.number,
                    inputPlaceHolder: "Write here...",
                    propName: "brokerPhoneNumber"
                }
            ] as IStep[];
        } else {
            return [
                {
                    isHeader: true,
                    title: "Contact Information",
                    inputType: InputTypes.none
                },
                {
                    title: "Your Full Name",
                    inputType: InputTypes.text,
                    propName: "fullName",
                    inputPlaceHolder: "Write here...",
                },
                {
                    title: "Work Email Address",
                    inputType: InputTypes.email,
                    propName: "workEmail",
                    errorController: !STORE.isEmailValid,
                    inputPlaceHolder: "Write here...",
                    errorLabel: STORE.getEmailErrorMessage
                },
                {
                    title: "Client's Name",
                    inputType: InputTypes.text,
                    inputPlaceHolder: "Write here...",
                    propName: "clientName"
                },
                {
                    title: "Client's Email",
                    inputType: InputTypes.email,
                    inputPlaceHolder: "Write here...",
                    propName: "clientEmail"
                },
                {
                    title: "Please specify the amount of their security deposit",
                    inputType: InputTypes.amount,
                    propName: "brokerClientDeposit"
                }
            ] as IStep[];
        }
    }
    public renderSteps = () => {
        switch (STORE.currentScreen) {
            case BrokersState.welcome: {
                return (
                    <div className="welcome-container">
                        <div className="header">Welcome Brokers!</div>
                        <div className="sub-header">Are you ready to close more deals with less friction? Get started now to make it happen</div>
                        <div className="workspace-selection">
                            <PlacesAutoCompleteContainer  placeholder={"Enter here"} inputLabel={"Please list your brokerage firm"} onPlaceSelected={this.selectPlace}  autoFocus={true} generalSearch={true}/>
                            <div className="btn-container">
                                {this.renderNextButton()}
                                {this.state.showWorkSpaceError? <div className="error">This field is mandatory: Please list a firm</div>: null}
                            </div>
                        </div>
                    </div>
                )
            }
            case BrokersState.informationClients:
            case BrokersState.informationContact: {
                const ContactInfoClasses =  STORE.currentScreen === BrokersState.informationContact? "contact-info" : "";
                return (<div className={ContactInfoClasses}>
                    <FormStepper steps={this.getSteps()} store={STORE} navigationProperty={storePropertyName}/>
                </div>)
            }
            case BrokersState.finish: return <FormFinish {...this.props} link={"http://www.salaryo.com/brokers"}/>;
            default: return null
        }
    };

    public goBack = () => {
        STORE.updateLocation();
        STORE.updateScreen(BrokersState.welcome);
    }

    public renderNavigation = () => {
        if (STORE.currentScreen === BrokersState.informationClients || STORE.currentScreen === BrokersState.informationContact) {
            return (
                <div className="form-navigation">
                    <ResetFormBtn/>
                    <div className="link-next">{this.renderSubmitButton()}</div>
                </div>);
        }
        return null;
    };

    public changeView = () => {
        STORE.formInput[storePropertyName] = {};
        STORE.updateFinishForm(false);
        const newScreen = STORE.currentScreen === BrokersState.informationContact?BrokersState.informationClients : BrokersState.informationContact;
        STORE.updateScreen(newScreen);
        const newState = this.state;
        newState.selectedView = !newState.selectedView;
        this.setState(newState);
    };
    public renderFormLink = () => {
        if (STORE.currentScreen === BrokersState.informationClients || STORE.currentScreen === BrokersState.informationContact) {
            const text = this.state.selectedView === BrokerView? "Refer clients" : "Sign up";
            const ContactInfoClasses =  STORE.currentScreen === BrokersState.informationContact? " contact-info-link" : "";
            return (<div className={"switch-view-btn-navigation" + ContactInfoClasses} onClick={this.changeView}> <span> {text} </span> <Icon icon={'chevronRight'}/> </div>);
        }
        return null;
    };

    public render() {
        return (
            <>
                {this.renderFormLink()}
                {this.renderSteps()}
                {this.renderNavigation()}
            </>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormBrokers/FormBrokers/FormBroker.tsx